
export default [
  {
    "ref": "kithflow-team",
    "name": "KithFlow",
    "avatar": "https://randomuser.me/api/portraits/men/81.jpg",
    "content": "",
    "_meta": {
      "filePath": "authors/kithflow-team.mdx",
      "fileName": "kithflow-team.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/kithflow-team"
    }
  }
]